<template>
    <div class="app-width">
        <h3 class="mb-3 pt-2" style="font-weight: bold; font-size: 1.4rem;">{{ $t("Gift information") }}</h3>
        <div class="desc mb-2" v-if="gift.description">
            {{ gift.description }}
        </div>
        <b-card class="mb-3">
            <h4 style="font-weight: bold; font-size: 1rem;">{{ $t("Goods list") }}:</h4>
            {{ gift.textItems }}
        </b-card>
        <div class="text-right">
            <b-button @click="claim" variant="primary mr-1" :disabled="loading">{{ $t("Claim") }}</b-button>
            <b-button @click="close" :disabled="loading">{{ $t("Close") }}</b-button>
        </div>
    </div>
</template>
<script>
import giftService from "@/services/giftService";
import dialogHelper from "@/helpers/dialogHelper";
export default {
    name: "GiftPanel",
    props: ["gift", "gameId", "roleId", "roleName", "serverId"],
    data: () => ({
        loading: false,
    }),
    methods: {
        close() {
            this.$emit("closePanel", {});
        },
        async claim() {
            this.loading = true;
            await this.$recaptchaLoaded();
            const response = await giftService.useGift({
                idGift: this.gift.id,
                gameId: this.gameId,
                roleId: this.roleId,
                roleName: this.roleName, 
                serverId: this.serverId
            }, await this.$recaptcha('useGift'));
            this.loading = false;
            if (!response)
            {
                await dialogHelper.alert("Connect to server failed. Please check your internet connection");
                return;
            }

            if (response.error) {
                await dialogHelper.alert(response.message);
                return;
            }

            await dialogHelper.alert(response.message, "success");
            
            this.$emit("closePanel", {id: this.gift.id});
        }
    }
}
</script>